import _ from 'lodash';

export function hasRevolvingCreditFacilityProduct(application) {
    const defaultDuration = 12;
    const requestedDuration = _.get(
        application,
        'loan_request.duration',
        defaultDuration
    );

    return requestedDuration <= 12;
}
